module.exports = __webpack_public_path__ + "img/placeholder.69582090.svg";